import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const mergeTeamsEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-eoc-merge-teams" */ './ui/MergeTeams.tsx'),
	),
	getPreloadProps: () => ({}),
});
